import moment from "moment";
import {
  dayMaxHour,
  dayMinHour,
  days,
  stringDay,
  stringNextDay,
  tasks,
  timeBreaks,
  MODAL_SUCCESS,
} from "./SettingsConstant";
import { TIME_PATTERN } from "../util/Constants";

export function calculateTime(startTime, endTime) {
  if (startTime === "" || endTime === "") return "";

  const startTime24hrs = moment()
    .hour(getHour(startTime))
    .minutes(getMinutes(startTime))
    .format("HH:mm");
  const endTime24hrs = moment()
    .hour(getHour(endTime))
    .minutes(getMinutes(endTime))
    .format("HH:mm");

  return startTime24hrs + "-" + endTime24hrs;
}

export function getHour(stringTime) {
  return new Date(stringDay + stringTime).getHours();
}

export function getMinutes(stringTime) {
  return new Date(stringDay + stringTime).getMinutes();
}

export function getDay(stringTime, stationTime) {
  const dayHour = getHour(stringTime);
  const dayMin = getMinutes(stringTime);
  const stationHour = stationTime.hour;
  const stationMin = stationTime.minute;

  if (dayHour === stationHour) {
    if (dayMin < stationMin) {
      return 2;
    }
    return 1;
  } else if (dayHour > stationHour && dayHour <= dayMaxHour) {
    return 1;
  } else if (dayHour >= dayMinHour && dayHour < stationHour) {
    return 2;
  }
}

export function getTime(stringTime) {
  if (stringTime === "") {
    return null;
  }
  return moment().hour(getHour(stringTime)).minute(getMinutes(stringTime));
}

function changeStartEndTime(data) {
  const startTimeIn24hrs = getTime(data.startTime.formattedTime).format(
    "HH:mm:ss",
  );
  const endTimeIn24hrs = getTime(data.endTime.formattedTime).format("HH:mm:ss");
  data.startTime.time = startTimeIn24hrs;
  data.endTime.time = endTimeIn24hrs;
}

/**
 * changing time format of the JSON data from  "time":{ "hour":9,"minute":0,"second":0,"nano":0 } to "time" : "09:00:00"
 * @param data
 */

function changeTimeFormat(data) {
  if (data.taskPlan) {
    tasks.forEach((task) => {
      if (data.taskPlan[task]) {
        changeStartEndTime(data.taskPlan[task]);
      }
    });
  }
  if (data.breaks) {
    timeBreaks.forEach((timeBreak) => {
      if (data.breaks[timeBreak]) {
        changeStartEndTime(data.breaks[timeBreak]);
      }
    });
  }
}

/**
 * function used to format JSON data obtained from backend to display in tabular format at UI
 * @param getPlans
 * @returns {{}}
 */

export function formatGetPlanDetails(getPlans) {
  let settingsInsights = {};
  days.forEach((day) => {
    settingsInsights[day] = [];
  });

  const plans = getPlans.stationPlanWithTargetsList;
  plans.forEach((data) => {
    changeTimeFormat(data);
    settingsInsights[data.dayOfTheWeek].push(data);
  });
  settingsInsights["shiftTimeRange"] = getPlans.shiftTimeRange;
  settingsInsights["cycleInfoList"] = getPlans.cycleInfoList;
  return settingsInsights;
}

export function checkNullTimings(plan) {
  if (plan.startTime.time === "" || plan.endTime.time === "") {
    return true;
  }
}

export function validCyclePlan(data) {
  if (!data.taskPlan) {
    return false;
  }

  if (!data.taskPlan.INDUCT || !data.taskPlan.SORT || !data.taskPlan.STAGE) {
    return false;
  }

  if (
    checkNullTimings(data.taskPlan.INDUCT) ||
    checkNullTimings(data.taskPlan.SORT) ||
    checkNullTimings(data.taskPlan.STAGE)
  ) {
    return false;
  }

  if (data.breaks) {
    timeBreaks.forEach((timeBreak) => {
      if (data.breaks[timeBreak] && checkNullTimings(data.breaks[timeBreak])) {
        data.breaks[timeBreak] = undefined;
      }
    });
  }

  return true;
}

export function isValidPlanAndAccordanceWithStationResetTime(plan) {
  var inductStartTime = new Date(
    stringDay + plan.taskPlan.INDUCT.startTime.time,
  );
  var stageEndTime = new Date(stringDay + plan.taskPlan.STAGE.endTime.time);

  if (plan.taskPlan.INDUCT.startTime.day === 2) {
    inductStartTime = new Date(
      stringNextDay + plan.taskPlan.INDUCT.startTime.time,
    );
  }

  if (plan.taskPlan.STAGE.endTime.day === 2) {
    stageEndTime = new Date(stringNextDay + plan.taskPlan.STAGE.endTime.time);
  }

  /* since we process timings on a 24hr buffer from ShiftStart->ResetTime to ShiftEnd->NextDay_ResetTime
   * i.e       ShiftStart----Day1----23, 0------Day2------ShiftEnd
   * so whenever inductStartTime and  stageEndTime cross boundaries they get mapped to Day2 and Day1 respectively
   * which results in inductStartTime(Day2) > stageEndTime(Day1).
   */

  if (inductStartTime > stageEndTime) {
    return false;
  } else {
    return true;
  }
}

export function adjustStateAfterSuccessfulDeletion(
  state,
  plan,
  responseStatus,
) {
  if (responseStatus === MODAL_SUCCESS) {
    if (state.settingsData[plan.dayOfTheWeek]) {
      let cyclesOfTheDay = state.settingsData[plan.dayOfTheWeek];
      state.settingsData[plan.dayOfTheWeek] = cyclesOfTheDay.filter(
        (cycle) => cycle !== plan,
      );
    }
  }
  return state;
}

export function getShiftTime(shiftTimeRange) {
  if (
    shiftTimeRange !== undefined &&
    shiftTimeRange.hour !== undefined &&
    shiftTimeRange.minute !== undefined &&
    shiftTimeRange.second !== undefined
  ) {
    var resetTime = new Date();
    resetTime.setHours(shiftTimeRange.hour);
    resetTime.setMinutes(shiftTimeRange.minute);
    resetTime.setSeconds(shiftTimeRange.second);

    return resetTime.toLocaleTimeString();
  }
}

export function formatTime(time, type) {
  const [, timeString, modifier] = time.split(" ");
  let [hours, minutes] = timeString.split(":");
  if (hours === "12") {
    hours = "00";
  }
  if (modifier === "PM") {
    hours = parseInt(hours, 10) + 12;
  }

  let newTime;

  if (hours > 0 && hours < 10) newTime = `0${hours}:${minutes}`;
  else newTime = `${hours}:${minutes}`;

  if (type === "timePicker") {
    return newTime + ":00";
  }

  return newTime;
}

export function isValidTimeFormat(timeString, format) {
  return timeString && format.test(timeString);
}

export const isTimeWithinInterval = (time, startTime, endTime) => {
  if (startTime > endTime) {
    return startTime < time || time < endTime;
  }
  return startTime < time && time < endTime;
};

export const isTimeWindowOverlappingWithOthers = (
  timeWindow,
  otherTimeWindows,
) => {
  return (
    otherTimeWindows
      .filter(
        (otherTimeWindow) =>
          isValidTimeFormat(otherTimeWindow.startTime, TIME_PATTERN) &&
          isValidTimeFormat(otherTimeWindow.endTime, TIME_PATTERN),
      )
      .filter(
        (otherTimeWindow) =>
          isTimeWithinInterval(
            timeWindow.startTime,
            otherTimeWindow.startTime,
            otherTimeWindow.endTime,
          ) ||
          isTimeWithinInterval(
            timeWindow.endTime,
            otherTimeWindow.startTime,
            otherTimeWindow.endTime,
          ) ||
          isTimeWithinInterval(
            otherTimeWindow.startTime,
            timeWindow.startTime,
            timeWindow.endTime,
          ) ||
          isTimeWithinInterval(
            otherTimeWindow.endTime,
            timeWindow.startTime,
            timeWindow.endTime,
          ) ||
          (timeWindow.startTime === otherTimeWindow.startTime &&
            timeWindow.endTime === otherTimeWindow.endTime),
      ).length > 0
  );
};

export function trimAndCapitalizeFirstLetter(str = "") {
  const trimmed = str.trim();
  if (!trimmed) return "";
  const [first, ...rest] = [...trimmed];
  return first.toUpperCase() + rest.join("").toLowerCase();
}



// WEBPACK FOOTER //
// ./src/components/settings/SettingsUtil.js